import { render, staticRenderFns } from "./ProviderPackage.vue?vue&type=template&id=7f798884&"
import script from "./ProviderPackage.vue?vue&type=script&lang=js&"
export * from "./ProviderPackage.vue?vue&type=script&lang=js&"
import style0 from "./ProviderPackage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports